var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8897 16.2955C6.8897 16.2955 8.59253 13.8689 10.878 13.8209C14.3948 13.7458 17.2658 20.0886 17.7043 21.0046C21.5905 12.3012 28.0324 4.9283 33.2671 0H1.15053C1.15353 3.02125 1.18356 33.492 1.18356 35.9877C1.18356 37.9668 0.916275 39.3723 0.766113 40C2.18364 39.7778 7.59245 38.8558 13.0824 36.8826C22.8368 33.3749 26.6599 29.6389 26.696 29.6028L26.9423 29.3566L27.0834 29.6749C27.0954 29.7019 28.3057 32.3808 29.519 33.8103C30.8645 35.396 31.6243 35.5822 32.0237 35.4561C32.5703 35.2879 32.9367 34.399 33.0899 32.8914C33.234 31.4528 33.3662 28.1673 33.3632 24.194C33.3601 17.0133 33.3632 7.5381 33.3632 2.77198C23.894 14.3885 16.9265 31.7892 16.9265 31.7892C16.9265 31.7892 12.3556 16.1844 6.8897 16.2955Z",
    fill: "#003059"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.ce26fc5dd39c00ebe083c913832be51c.svg";
export { ForwardRef as ReactComponent };